import React, { useEffect, useState } from 'react';
import './subscription.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import Pagination from '../../../components/base/Pagination/Pagination';
import {
  deleteInterval,
  loadCurrentIntervalById,
  loadCurrentIntervalByIdClear,
  loadIntervalList,
} from '../actions';
import { getPaginationOpts, responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';
import { getSubscriptionData } from '../reducer';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import IntervalDialog from './IntervalDialog';
import SeparateBox from '../../../components/base/SeparateBox/SeparateBox';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import getDefaultDataRange from '../../../utils/getDefaultDataRange';
import { showGlobalConfirm } from '../../System/actions';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { getSystemData } from '../../System/reducer';
import { dateTimeFormatter } from '../../../utils/formatters';

export default function IntervalGrid({ hasView = false }) {
  const momentRangeObject = getDefaultDataRange(1, 'month');
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [dateFilter, setDateFilter] = useState(momentRangeObject);
  const {
    currentSubscription,
    intervalList,
    intervalListMeta,
  } = useSelector(getSubscriptionData);
  const { updatePeriod } = useSelector(getSystemData);

  const handleChangeDate = value => {
    setDateFilter(value);
  };

  const loadIntervals = opts => {
    if (!currentSubscription) {
      return Promise.all([]);
    }
    const filterData = {
      start_at_from: dateFilter[0],
      start_at_to: dateFilter[1],
    };
    const paginationOpts = getPaginationOpts(intervalListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: filterData,
      id: currentSubscription.id,
    };
    const p1 = dispatch(loadIntervalList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const handleAddInterval = () => {
    setShowForm(true);
  };

  const handleEditInterval = item => e => {
    dispatch(loadCurrentIntervalById({ id: currentSubscription.id, iId: item.id }))
      .then(() => {
        setShowForm(true);
      })
      .catch(responseLogWithNotification);
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDeleteInterval = item => e => {
    dispatch(showGlobalConfirm({
      confirmTitle: 'Удаление интервала',
      confirmMessage: `Вы уверены, что хотите удалить интервал ${item.id}?`,
      confirmButtonText: 'Удалить',
    })).then(() => {
      dispatch(deleteInterval({ id: currentSubscription.id, iId: item.id }))
        .then(() => {
          loadIntervals();
          notificationDecorator({
            title: 'Удаление интервала',
            message: 'Успешно',
          });
        })
        .catch(responseLogWithNotification);
    }).catch(() => {});
    e.preventDefault();
    e.stopPropagation();
  };

  const handleClose = () => {
    dispatch(loadCurrentIntervalByIdClear());
    setShowForm(false);
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleEditInterval(item)}>
            Редактировать
          </Button>
          <Button variant="link" className="w-100 more-button delete" onClick={handleDeleteInterval(item)}>
            Удалить
          </Button>
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const columns = [
    {
      dataField: 'start_at',
      text: 'Начало периода',
      disableSort: true,
      formatter: dateTimeFormatter,
      toCopyFormatter: dateTimeFormatter,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'end_at',
      text: 'Конец периода',
      disableSort: true,
      formatter: dateTimeFormatter,
      toCopyFormatter: dateTimeFormatter,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'payment_id',
      text: 'Платеж',
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'payment_id',
      text: '',
      headerClassName: 'settings-column align-middle text-center',
      dataClassName: 'settings-column row-full-click align-middle no-avtive',
      disableSort: true,
      formatter: moreFormatter,
    },
  ];

  const [setPeriod, destroy] = useUpdatePeriod(loadIntervals, updatePeriod);
  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);

  useEffect(() => {
    loadIntervals();
  }, [JSON.stringify(dateFilter)]);

  return (
    <div className="interval-grid-column">
      <div className="d-flex flex-row justify-content-between align-items-center">
        <div className="h4">
          Оплаченные интервалы
        </div>
        <div className="inputs">
          <RangeDatePicker
            value={momentRangeObject}
            hideSmallButtons
            usePortal
            hidePickerIcon
            showArrowIcon
            className="no-border"
            handleChangeDate={handleChangeDate}
            // disabled={!currentSubscription?.id}
          />
          {!hasView ? (
            <>
              <SeparateBox />
              <Button disabled={!currentSubscription?.id} onClick={handleAddInterval}>Добавить период</Button>
            </>
          ) : null}

        </div>
      </div>
      <div className="interval-grid-wrapper mt-3">
        <Grid data={intervalList} columns={columns} />
      </div>

      <Pagination meta={intervalListMeta} list={intervalList} handleChangeMeta={loadIntervals} />
      {showForm ? <IntervalDialog handleClose={() => { handleClose(); }} loadData={loadIntervals} /> : null}
    </div>
  );
}
